import CModal from '../CModal';
import { IconStar } from '@tabler/icons-react';
import { useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { apiV1 } from '../../utils/apiClient';
import { useEffect, useState } from 'react';
import { profileQueryOptions, salesPointsQueryOptions } from '../../utils/queryOptions';
import { Input, InputNumber, message, Select } from 'antd';
import { z } from 'zod';

interface RedeemPointsModalProps {
  open: boolean,
  onClose: () => void,
  customerId: string,
}

const AddPointsModal = ({ open, onClose, customerId }: RedeemPointsModalProps) => {

  const salesPoints = useSuspenseQuery(salesPointsQueryOptions());
  const queryClient = useQueryClient()

  const [amount, setAmount] = useState<number | null>(0);

  const salesPointsOptions = salesPoints.data.map((point) => ({
    value: point.id,
    label: point.name
  }));
  const [selectedSalesPointId, setSelectedSalesPointId] = useState('');

  useEffect(() => {
    const savedSalesPointId = localStorage.getItem('selectedSalesPointId');
    if (savedSalesPointId) {
      setSelectedSalesPointId(savedSalesPointId);
    } else {
      setSelectedSalesPointId(salesPoints.data[0].id);
    }
  }, []);

  const addPoints = {
    mutationFn: async () => {
      const cleanAmount = await z.coerce.number().parseAsync(amount);
      return await apiV1.post('/shop/transactions/add-points', {
        amount: cleanAmount,
        user_id: customerId,
        sales_point_id: selectedSalesPointId
      });
    },
    onSuccess: (data:any) => {
      message.success(`Sono stati aggiunti ${data.details} punti`);
      queryClient.invalidateQueries({queryKey: ['customers']})
      queryClient.invalidateQueries({queryKey: ['customer', customerId]})
      queryClient.invalidateQueries({queryKey: ['customer-history', customerId]})
      queryClient.invalidateQueries({queryKey: ['customers-details']})
      setAmount(0)
      onClose()
    }
  };



  async function saveSalesPointPreference(salesPointId: string) {
    setSelectedSalesPointId(salesPointId);
    localStorage.setItem('selectedSalesPointId', salesPointId);
    message.success('Preferenza salvata');
  }

  return (
    <CModal disabled={!amount} title={'Assegna punti al cliente'} open={open} onClose={onClose} icon={<IconStar />}
            mutationOptions={addPoints}>
      <p className={'font-medium mt-3'}>Punto vendita</p>
      <Select options={salesPointsOptions} value={selectedSalesPointId} onSelect={saveSalesPointPreference}
              className={'w-full'} />
      <p className={'font-medium mt-2'}>Importo</p>
      <InputNumber className={'w-full'} suffix={'€'} value={amount} onChange={(value)=>setAmount(value)} />
    </CModal>
  );
};
export default AddPointsModal;
